export const addMenuPageLanguage = {
    en: {
        CatalogID: 'Catalog ID',
        PageNumber: 'Page Number',
        PageName: 'Page Name',
        CurrentPageImage: 'Current Page Image',
        UploadPageImage: 'Upload Page Image',
        Status: 'Status',
        Submit: 'Submit',
        Cancel: 'Cancel',
        'status.active': 'Active',
        'status.inactive': 'Inactive',
        OpenModal: 'Select Products',
        'Failed to submit page. Please try again later.': 'Failed to submit page. Please try again later.',
        AddEditPage: 'Add/Edit Page',
        PageList: 'Page List',
        AddPage: 'Add Page',
        PageImage: 'Page Image',
        Action: 'Action',
    },
    th: {
        CatalogID: 'รหัสแคตตาล็อก',
        PageNumber: 'หมายเลขหน้า',
        PageName: 'ชื่อหน้า',
        CurrentPageImage: 'รูปภาพหน้าปัจจุบัน',
        UploadPageImage: 'อัปโหลดรูปภาพหน้า',
        Status: 'สถานะ',
        Submit: 'บันทึก',
        Cancel: 'ยกเลิก',
        'status.active': 'ใช้งาน',
        'status.inactive': 'ไม่ใช้งาน',
        OpenModal: 'เลือกสินค้า',
        'Failed to submit page. Please try again later.': 'บันทึกหน้าไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
        AddEditPage: 'เพิ่ม/แก้ไขหน้า',
        PageList: 'รายการหน้า',
        AddPage: 'เพิ่มหน้า',
        PageImage: 'รูปภาพหน้า',
        Action: 'การดำเนินการ',
    },
    cn: {
        CatalogID: '目录ID',
        PageNumber: '页码',
        PageName: '页面名称',
        CurrentPageImage: '当前页面图片',
        UploadPageImage: '上传页面图片',
        Status: '状态',
        Submit: '提交',
        Cancel: '取消',
        'status.active': '启用',
        'status.inactive': '禁用',
        OpenModal: '选择商品',
        'Failed to submit page. Please try again later.': '页面提交失败，请稍后再试。',
        AddEditPage: '添加/编辑页面',
        PageList: '页面列表',
        AddPage: '添加页面',
        PageImage: '页面图片',
        Action: '操作',
    },
    jp: {
        CatalogID: 'カタログID',
        PageNumber: 'ページ番号',
        PageName: 'ページ名',
        CurrentPageImage: '現在のページ画像',
        UploadPageImage: 'ページ画像をアップロード',
        Status: 'ステータス',
        Submit: '送信',
        Cancel: 'キャンセル',
        'status.active': '有効',
        'status.inactive': '無効',
        OpenModal: '商品を選択',
        'Failed to submit page. Please try again later.': 'ページの送信に失敗しました。後でもう一度お試しください。',
        AddEditPage: 'ページの追加/編集',
        PageList: 'ページリスト',
        AddPage: 'ページを追加',
        PageImage: 'ページ画像',
        Action: 'アクション',
    },
    kr: {
        CatalogID: '카탈로그 ID',
        PageNumber: '페이지 번호',
        PageName: '페이지 이름',
        CurrentPageImage: '현재 페이지 이미지',
        UploadPageImage: '페이지 이미지 업로드',
        Status: '상태',
        Submit: '제출',
        Cancel: '취소',
        'status.active': '활성',
        'status.inactive': '비활성',
        OpenModal: '상품 선택',
        'Failed to submit page. Please try again later.': '페이지 제출에 실패했습니다. 나중에 다시 시도하세요.',
        AddEditPage: '페이지 추가/편집',
        PageList: '페이지 목록',
        AddPage: '페이지 추가',
        PageImage: '페이지 이미지',
        Action: '작업',
    },
}